import { ResultPagDTO } from "@/interfaces/base-dto";
import { AnaliseFiltroPagDTO, AnaliseParmDTO, PacientePropostaFreteDTO, PropostaAprovacaoParmDTO, PropostaEfetivacaoParmDTO, PropostaFreteSolicParmDTO, SolicitacaoFiltroPagDTO } from "@/interfaces/shipping-quote";
import { ENDPOINTS } from "@/settings/api-settings";
import { from, Observable } from "rxjs";
import { map } from "rxjs/operators";
import { apiClient } from "./api";


export function listClientsUnitsShippingQuoteRequest(): Observable<any> {
  return from(apiClient.get(`${ENDPOINTS.SHIPPING_QUOTE_CLIENT_UNITS}`)).pipe(
    map((r: any) => r.data),
  );
}

export function saveShippingQuoteRequest(parm: PropostaFreteSolicParmDTO): Observable<any> {
  return from(apiClient.post(`${ENDPOINTS.SHIPPING_QUOTE_REQUEST}`, parm)).pipe(
    map((r: any) => r.data),
  );
}

export function listShippingQuoteRequest(filters: SolicitacaoFiltroPagDTO): Observable<ResultPagDTO<any>> {
  return from(apiClient.get(`${ENDPOINTS.SHIPPING_QUOTE_REQUEST}`, filters)).pipe(
    map((r: any) => r.data),
  );
}

export function getShippingQuoteRequest(key: String): Observable<any> {
  return from(apiClient.get(`${ENDPOINTS.SHIPPING_QUOTE_REQUEST}/${key}`)).pipe(
    map((r: any) => r.data),
  );
}

export function listShippingQuoteStatuses(): Observable<any> {
  return from(apiClient.get(`${ENDPOINTS.SHIPPING_QUOTE_STATUSES}`)).pipe(
    map((r: any) => r.data),
  );
}

export function listShippingQuoteClientUnits(): Observable<any> {
  return from(apiClient.get(`${ENDPOINTS.SHIPPING_QUOTE_CLIENTUNITS}`)).pipe(
    map((r: any) => r.data),
  );
}

export function listShippingQuotePatients(): Observable<any> {
  return from(apiClient.get(`${ENDPOINTS.SHIPPING_QUOTE_PATIENTS}`)).pipe(
    map((r: any) => r.data),
  );
}

export function getShippingQuotePatientDetails(id: number, idClientUnit: number): Observable<any> {
  return from(apiClient.get(`${ENDPOINTS.SHIPPING_QUOTE_PATIENTS}/${id}/${idClientUnit}`)).pipe(
    map((r: any) => r.data),
  );
}

export function listShippingQuoteUsers(): Observable<any> {
  return from(apiClient.get(`${ENDPOINTS.SHIPPING_QUOTE_USERS}`)).pipe(
    map((r: any) => r.data),
  );
}

export function listShippingQuoteAnalise(filters: AnaliseFiltroPagDTO): Observable<ResultPagDTO<any>> {
  return from(apiClient.get(`${ENDPOINTS.SHIPPING_QUOTE_ANALISE}`, filters)).pipe(
    map((r: any) => r.data),
  );
}

export function getShippingQuoteAnalise(key: String): Observable<any> {
  return from(apiClient.get(`${ENDPOINTS.SHIPPING_QUOTE_ANALISE}/${key}`)).pipe(
    map((r: any) => r.data),
  );
}

export function listShippingQuoteAnaliseHist(key: String): Observable<any> {
  return from(apiClient.get(`${ENDPOINTS.SHIPPING_QUOTE_ANALISE}/${key}/historicos`)).pipe(
    map((r: any) => r.data),
  );
}

export function saveShippingQuoteAnalise(parm: AnaliseParmDTO): Observable<string> {
  return from(apiClient.post(`${ENDPOINTS.SHIPPING_QUOTE_ANALISE}`, parm)).pipe(
    map((r: any) => r.data),
  );
}

export function saveShippingQuoteClientApprove(parm: PropostaAprovacaoParmDTO): Observable<string> {
  return from(apiClient.put(`${ENDPOINTS.SHIPPING_QUOTE_REQUEST}`, parm)).pipe(
    map((r: any) => r.data),
  );
}

export function saveShippingQuoteAnaliseApprove(parm: PropostaEfetivacaoParmDTO): Observable<string> {
  return from(apiClient.put(`${ENDPOINTS.SHIPPING_QUOTE_ANALISE}`, parm)).pipe(
    map((r: any) => r.data),
  );
}